import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'What ages does this work for?',
    answer: "The anchors work best for homes with kids ages 3–12. The scripts adapt to your child's level. For younger toddlers, it helps *you* stay regulated even if they don't fully get it yet."
  }, {
    question: 'How much time does this take per day?',
    answer: "Day 0 setup takes ~10 minutes. After that, each anchor takes 3–6 minutes. The whole point is that it's low-effort. It gives you time back, rather than taking it."
  }, {
    question: "I've tried routines before and they never stick. Why is this different?",
    answer: "Because this isn't a routine—it's three friction locks. Each one has a minimum viable version for bad days, so you never fully 'fall off' the wagon. It's built for real life, not Instagram life."
  }, {
    question: 'Is this a physical product?',
    answer: "No—it's an instant PDF download. You'll get access immediately after purchase. You can read it on your phone or print the specific pages you need (like the script cards)."
  }, {
    question: "What if it doesn't work for me?",
    answer: "Email me and I'll refund you. No questions, no guilt. But give it 5 days first—that's usually when the 'quiet' starts to set in."
  }, {
    question: 'Do I need a partner or co-parent for this to work?',
    answer: 'No. This was designed specifically for solo moms running the house alone. No co-parent coordination needed. You are the anchor.'
  }];
  return <section className="py-24 px-6 bg-[#F2EFE9]" data-id="element-32">
      <div className="max-w-3xl mx-auto" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-34">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-4" data-id="element-35">
            Questions before you start
          </h2>
          <p className="text-charcoal/60" data-id="element-36">
            Everything you need to know about the reset.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-37">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: i * 0.05
        }} className="bg-white rounded-xl border border-charcoal/5 overflow-hidden" data-id="element-38">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left hover:bg-linen/50 transition-colors" data-id="element-39">
                <span className="font-bold text-charcoal text-lg pr-8" data-id="element-40">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-muted-blue transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-41" />
              </button>
              <AnimatePresence data-id="element-42">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-43">
                    <div className="px-6 pb-6 pt-0 text-charcoal/80 leading-relaxed border-t border-charcoal/5 mt-2" data-id="element-44">
                      <div className="pt-4" data-id="element-45">{faq.answer}</div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}